if (!EE) {
    // logic for tab component
    const tabComponents = document.querySelectorAll('.tab-component:not(.gallery-links-wrapper)');
    if (tabComponents) {
        tabComponents.forEach((tabComponent, index) => {
            const tabItemLink = tabComponent.querySelector('.tab-item-link');
            const tabContentWrapper = tabComponent.querySelector('.tab-content-wrapper');
            //make first tab and content visible on page load
            if (tabItemLink && tabContentWrapper) {
                let activeTabSet = false;

                const urlHash = window.location.hash.split('#')[1];
                if (urlHash) {
                    const targetTab = tabComponent.querySelector(`.tab-item-link button[data-id="${urlHash}"]`);
                    if (targetTab) {
                        window.addEventListener('load', () => {
                            let activeTabId = urlHash;
                            setActiveTab(tabComponent, activeTabId);
                        });
                        activeTabSet = true;
                    } 
                } 
                
                if (!activeTabSet) {
                    let activeTabLink = tabItemLink.querySelector('.active');
                    let activeContent = tabContentWrapper.querySelector('.active');
                    if ( !(activeTabLink && activeContent)) {
                        window.addEventListener('load', () => {
                            let activeTabId = tabItemLink.firstElementChild.dataset.id;
                            setActiveTab(tabComponent, activeTabId);
                        });
                    }
                }

                //handle tab functionality on click for every tab item
                let handleClick = (e) => {
                    let tabComponent = e.target.parentElement.parentElement;
                    let activeTabId = e.target.dataset.id;
                    setActiveTab(tabComponent, activeTabId);
                };
                
                Array.from(tabComponents[index].querySelectorAll('.tablinks'), (btn) =>
                {
                    btn.addEventListener('click', handleClick, false);
                });

            }  
        });
    }
}
  
// set active tab
function setActiveTab(tabComponent, activeTabId) {
    // remove `active` class from every element which has it
    Array.from(tabComponent.querySelectorAll('.active'), (e) =>
      e.classList.remove('active')
    );
    // set the tab and content to be active:
    const tabButton = tabComponent.querySelector(`button.tablinks[data-id="${activeTabId}"]`);
    const tabContent = tabComponent.querySelector(`div.tab-item-content[data-id*="${activeTabId}"]`);
    tabButton.classList.add('active');
    tabContent.classList.add('active');
}
  
  